import React from 'react';
import { css } from '@emotion/css';
import LargeOverflowMenu from '../general/LargeOverflowMenu';
import { OverflowOption } from '../general/overflowMenu/OverflowMenu';
import { CountButton } from '../../scenes/contentPage/components/CountButton';
import styled from '@emotion/styled';

const webhookIcon = require('../../content/images/webhooks/webhook-dark.svg');
const computerLockDark = require('../../content/images/data-sensitivity/computer-lock-large.svg');
const computerLockBlue = require('../../content/images/data-sensitivity/computer-lock-large-blue.svg');

interface ContentInfoOptionsProps {
    optionSelected: (s: string) => void
    manageWebhooks: () => void
    options: OverflowOption[]
    webhookCount: number
    showSensitiveConversation: boolean,
    toggleSensitiveConversation: () => void
    showDisabledForFeatures: boolean,
    toggleDisabledForFeatures: () => void
    flagsSelected?: number
}

const ContentInfoOptions: React.FC<ContentInfoOptionsProps> = (props) => (
    <div className={containerStyle}>
        <CountButton
            isActive={props.showSensitiveConversation}
            onClick={() => { props.toggleSensitiveConversation(); }}
            activeIcon={computerLockBlue}
            inactiveIcon={computerLockDark}
            showCount={false}
            text="Secure Conversation"
        />
        <CountButton
            isActive={props.showDisabledForFeatures}
            onClick={() => { props.toggleDisabledForFeatures(); }}
            showCount={true}
            text="Disabled for Features"
            count={props.flagsSelected}
        />
        <WebhookCountButton
            onClick={(e) => { e.stopPropagation(); props.manageWebhooks(); }}
            text="Webhooks"
            showCount={true}
            count={props.webhookCount}
            inactiveIcon={webhookIcon}
        />
        <LargeOverflowMenu className="ac-content-info-overflow" isActive={false} onOptionSelected={props.optionSelected} options={props.options} />
    </div>
);

const WebhookCountButton = styled(CountButton)`
    height: 32px;
`;

const containerStyle = css`
    margin-left: auto;
    margin-right: 8px;
    display: flex;
    flex-direction: row;
    align-items: center;
`;

export default ContentInfoOptions;